module.exports = __webpack_public_path__ + "img/iccid_tw.523e7516.png";